import { differenceInCalendarDays, format, isValid, parseISO } from 'date-fns';
import type { EpcScheduleTaskRow } from '../../types/scheduleTask';

export function formatDateCell(raw: unknown): string {
  if (raw == null || raw === '') return '—';
  const s = String(raw);
  const d = parseISO(s.length >= 10 ? s.slice(0, 10) : s);
  if (!isValid(d)) return s.slice(0, 16);
  try {
    return format(d, 'dd MMM yyyy');
  } catch {
    return s.slice(0, 16);
  }
}

/** ISO date for `<time dateTime>` and tooltips. */
export function formatDateIso(raw: unknown): string {
  if (raw == null || raw === '') return '';
  const s = String(raw);
  const d = parseISO(s.length >= 10 ? s.slice(0, 10) : s);
  if (!isValid(d)) return '';
  try {
    return format(d, 'yyyy-MM-dd');
  } catch {
    return '';
  }
}

export function parseTaskDay(raw: unknown): Date | null {
  if (raw == null || String(raw).trim() === '') return null;
  const d = parseISO(String(raw).slice(0, 10));
  return isValid(d) ? d : null;
}

/** Inclusive calendar-day span when both dates are valid. */
export function calendarSpanInclusive(startRaw: unknown, finishRaw: unknown): number | null {
  const s = parseTaskDay(startRaw);
  const f = parseTaskDay(finishRaw);
  if (!s || !f) return null;
  const n = differenceInCalendarDays(f, s) + 1;
  return n >= 1 ? n : null;
}

export function scheduleRangeTooltip(t: EpcScheduleTaskRow): string {
  const sIso = formatDateIso(t.start);
  const fIso = formatDateIso(t.finish);
  const sDisp = formatDateCell(t.start);
  const fDisp = formatDateCell(t.finish);
  const parts: string[] = [];
  parts.push(sIso ? `Start ${sIso} (${sDisp})` : `Start ${sDisp}`);
  parts.push(fIso ? `Finish ${fIso} (${fDisp})` : `Finish ${fDisp}`);
  const span = calendarSpanInclusive(t.start, t.finish);
  if (span != null) {
    parts.push(`${span} calendar day${span === 1 ? '' : 's'} (inclusive)`);
  }
  return parts.join(' · ');
}
